import { Component } from "@kluntje/core";

/**
 * Custom Element to enable Sling Dynamic Includes
 */
class FRASdiContent extends Component {
  constructor() {
    super({
      // nothing to override here
    });
  }

  /**
   * Load SDI content from URL
   */
  afterComponentRender(): void {
    const contentUrl = this.getAttribute("data-content-url");
    if (contentUrl) {
      fetch(contentUrl)
        .then(response => {
          return response.text();
        })
        .then(html => {
          this.innerHTML = html;
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  }
}

customElements.define("fra-m-sdi-content", FRASdiContent);

export default FRASdiContent;
